import { useCallback, useState } from 'react';
import { UpdatedSuggestionProjectNames } from './types';

export type UseSuggestionsEditsResult = {
  removedSuggestionIds: number[];
  updatedSuggestionProjectNames: UpdatedSuggestionProjectNames;
  removeSuggestion: (id: number) => void;
  updateSuggestionProjectName: (id: number, projectName: string) => void;
};

/**
 * Hook to manage suggestions edits.
 */
export default function useSuggestionsEdits(): UseSuggestionsEditsResult {
  const [removedSuggestionIds, setRemovedSuggestionIds] = useState<number[]>(
    [],
  );
  const [
    updatedSuggestionProjectNames,
    setUpdatedSuggestionProjectNames,
  ] = useState<UpdatedSuggestionProjectNames>({});

  const removeSuggestion = useCallback((id: number): void => {
    setRemovedSuggestionIds(ids => ids.concat(id));
  }, []);

  const updateSuggestionProjectName = useCallback(
    (id: number, projectName: string): void => {
      setUpdatedSuggestionProjectNames(projectNames => ({
        ...projectNames,
        [id]: projectName,
      }));
    },
    [],
  );

  return {
    removedSuggestionIds,
    updatedSuggestionProjectNames,
    removeSuggestion,
    updateSuggestionProjectName,
  };
}
